import { UserRoles } from '@securecore-new-application/securecore-datacore/lib/types';
import { FC, ReactElement } from 'react';

import { useCurrentUser } from '../../hooks';

interface Props {
  roles: UserRoles[];
  children: ReactElement;
}

export const AccessWrapper: FC<Props> = ({ children, roles }) => {
  const user = useCurrentUser();

  const hasAccess = roles.includes(user?.role as UserRoles);

  return hasAccess ? children : null;
};
